(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("@tableau/widgets"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "@tableau/widgets"], factory);
	else if(typeof exports === 'object')
		exports["VizViewerToolbar"] = factory(require("react"), require("@tableau/widgets"));
	else
		root["VizViewerToolbar"] = factory(root["React"], root["SharedWidgets"]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__4098__, __WEBPACK_EXTERNAL_MODULE__272__) {
return 